import type { CreateUpdateCashierFormOutput } from "@/composables/forms/useCreateUpdateCashierForm"
import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const createCashier = async (
  params: CreateUpdateCashierFormOutput
) => {
  await api.post("/cashiers/", {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })
}
